module.exports = __webpack_public_path__ + "img/integrity.a9c9c4d5.png";